import { MediaObject } from "../../types/Entities/MediaObject/MediaObject";
import Typography from "@mui/material/Typography";
import React from "react";
import { API_HOST, API_PATH } from "../../config/_entrypoint";
import CardActionArea from "@mui/material/CardActionArea";
import DownloadIcon from "@mui/icons-material/Download";
import Grid from "@mui/material/Grid";
import dayjs from "dayjs";
import { Stack } from "@mui/material";

type MediaObjectRowProps = {
  mediaObject: MediaObject;
};

const MediaObjectRow = ({ mediaObject }: MediaObjectRowProps) => {
  const downloadLink = API_HOST + API_PATH + "/download/" + mediaObject.id + "?token=" + localStorage.getItem("token");

  return (
    <CardActionArea component={"a"} href={downloadLink} sx={{ padding: "0.5rem 0" }}>
      <Grid
        container
        sx={{
          justifyContent: "space-between",
        }}
      >
        <Grid sx={{ overflowWrap: "break-word" }} size={10}>
          <Typography variant={"body2"}>
            <strong>{mediaObject.description}</strong>
          </Typography>
          <Typography
            sx={(theme) => ({
              color: theme.palette.text.secondary,
            })}
          >
            {dayjs(mediaObject.created).format("D. MMMM YYYY")}
          </Typography>
        </Grid>
        <Grid>
          <Stack sx={{ justifyContent: "center", height: "100%", paddingRight: "0.5rem" }}>
            <DownloadIcon color={"primary"} />
          </Stack>
        </Grid>
      </Grid>
    </CardActionArea>
  );
};

export default MediaObjectRow;
